
/* Funzioni per la conversione degli orari */

export function convertOra(date){
    var time = new Date(date);
  
    const timeFinal = time.getHours() + ":" + (time.getMinutes()<10 ? '0': '') + time.getMinutes();
    
    return  (date === undefined ) ? "" : timeFinal
  }


export function parsinghour(date){
  let time = parseInt(date / 60)
  var hours = Math.floor(time /60)
  var minutes = time % 60
  const timeFinal =  (hours >0) ? hours + " h " : null + minutes + " min"
  return timeFinal
}


